import { render } from "./ProductCharacteristicsRoster17Screen.vue?vue&type=template&id=37876be1&scoped=true"
const script = {}

import "./ProductCharacteristicsRoster17Screen.vue?vue&type=style&index=0&id=37876be1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37876be1"]])

export default __exports__